import { Navigate } from 'react-router-dom';
import { isLoggedIn } from '../auth';
import { getCurrentUserRole } from './authHelper';

export default function SuperAdminRoute({ children }) {
    if (!isLoggedIn()) return <Navigate to="/" />;
    const role = getCurrentUserRole();
    if (role !== 'super_admin') return <Navigate to="/kpi" />;
    return children;
}
